export default "__VITE_ASSET__B0SoE9oi__"